// Shared suit symbol utility component per constitution UI Standards
// Uses Arimo font-family (Arial-compatible, self-hosted) with color coding (black for clubs/spades, red for diamonds/hearts)

interface SuitSymbolProps {
  suit: 'C' | 'D' | 'H' | 'S' | 'clubs' | 'diamonds' | 'hearts' | 'spades';
  className?: string;
}

const SUIT_SYMBOLS: Record<string, { symbol: string; color: string }> = {
  C: { symbol: '\u2663', color: 'text-black' },      // Club
  D: { symbol: '\u2666', color: 'text-red-600' },    // Diamond
  H: { symbol: '\u2665', color: 'text-red-600' },    // Heart
  S: { symbol: '\u2660', color: 'text-black' },      // Spade
  clubs: { symbol: '\u2663', color: 'text-black' },
  diamonds: { symbol: '\u2666', color: 'text-red-600' },
  hearts: { symbol: '\u2665', color: 'text-red-600' },
  spades: { symbol: '\u2660', color: 'text-black' },
};

export function SuitSymbol({ suit, className = '' }: SuitSymbolProps) {
  const suitInfo = SUIT_SYMBOLS[suit];

  if (!suitInfo) {
    return null;
  }

  return (
    <span
      // `suit-glyph` fixes the size site-wide (see index.css) so the symbols match the
      // hand display everywhere instead of tracking their neighbouring text. The
      // masthead opts out with `suit-glyph-inherit`.
      className={`font-suits suit-glyph ${suitInfo.color} ${className}`}
      aria-label={suit.length === 1 ? getSuitName(suit) : suit}
    >
      {suitInfo.symbol}
    </span>
  );
}

function getSuitName(abbrev: string): string {
  switch (abbrev) {
    case 'C': return 'clubs';
    case 'D': return 'diamonds';
    case 'H': return 'hearts';
    case 'S': return 'spades';
    default: return abbrev;
  }
}
